import React from 'react';
import Cell from '../Cell';

const BodyCell = ({ className, column, row, style, type, ...props }) => (
  <Cell
    {...props}
    placement="body"
    className={className}
    column={column}
    row={row}
    style={style}
    type={type}
  />
);

export default BodyCell;
